import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
  } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NecAuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';


/**
 * Http Requestæ¦æªå¨, ç¨äºç»ç»å½ååéçè¯·æ±å¤´èªå¨æ·»å Authorizationå­æ®µ
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  authService: NecAuthService;

  /**
   * æ³¨å¥NecAuthService(å¼æ­¥æ¯é²æ­¢åå§åæ¥é)
   */
  constructor(private injector: Injector) {
    setTimeout(() => {
      this.authService = this.injector.get(NecAuthService);
    });
  }

  /**
   * å®ç°æ¥å£
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // é²æ­¢authServiceæªæ³¨å¥
    if (!this.authService) {
      this.authService = this.injector.get(NecAuthService);
    }

    // ç»ç»å½ååéçè¯·æ±çè¯·æ±å¤´æ·»å Authorizationå­æ®µ
    if (this.authService.authenticate() && req.url.indexOf('/oauth/token') < 0) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.authService.getToken().access_token
        }
      });
      return next.handle(authReq);
    }
    else {
      return next.handle(req);
    }
  }
}
